@use "ui/styles/colors";

.wrapper {
  background-color: colors.$gray30;
  height: 1px;
  border: 0;
  margin: 0;
}
